import {
  ProjectType,
  ProjectTypeDisplayNames
} from '../../../enum/ProjectType.enum'
import React, { useState } from 'react'
import {
  getAllQueryParamsAsObjectFromUrl,
  replaceUrl
} from '../../../utils/UrlUtils'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { Button } from '../../../components/New/Button/Button'
import CCApiMonitoring from './ApiMonitoring/CCApiMonitoring'
import CCExceptionManagement from './ExceptionManagement/CCExceptionManagement'
import CCIncidents from './Incident/CCIncidents'
import CCScheduledJobs from './ScheduledJobs/CCScheduledJobs'
import CCUptimeChecks from './UptimeChecks/CCUptimeChecks'
import { CreateProject } from '../../../api/project/Project.service'
import { DDSTypography } from 'den-design-system'
import Input from '../../../components/New/Input/Input'
import Joi from 'joi'
import { OrganizationType } from '../../../enum/OrganizationType.enum'
import { OrganizationUserRoles } from '../../../enum/OrganizationUserRoles.enum'
import RegexConstants from '../../../constants/RegexConstants'
import Select from '../../../components/New/Select/Select'
import { SettingAddPopup } from '../../NewVersion/Settings/SettingPopups/SettingAddPopup'
import SettingConstants from '../../../constants/SettingConstants'
import SideChip from '../../../components/New/SideChip/SideChip'
import StringConstants from '../../../constants/StringConstants'
import Tabs from '../../../components/common/DDS/Tabs/Tabs'
import { ToastMessageConstants } from '../../../constants/ToastMessageConstants'
import ToastNotification from '../../../components/common/DDS/Toast/Toast'
import UrlConstants from '../../../constants/UrlConstants'
import { checkNameAvailability } from '../../../api/common/Common.service'
import { dateRange } from '../../../utils/OverviewUtils'
import { observer } from 'mobx-react-lite'
import palette from '../../../global/newPallete'
import routeConstants from '../../../constants/RouteConstants'
import { useStoreContext } from '../../../store/StoreContext'

const ControlCenter: React.FC = () => {
  const store = useStoreContext()
  const [searchParams, setSearchParams] = useSearchParams()

  const [createProjectPopupOpen, setCreateProjectPopupOpen] = useState(false)
  const [projectName, setProjectName] = useState('')
  const [projectType, setProjectType] = useState('')
  const [checkLoading, setCheckLoading] = useState(false)
  const [tabIndex, setTabIndex] = React.useState<string>(
    searchParams.get('tab') ?? '1'
  )
  const [isNameAvailable, setIsNameAvailable] = useState<boolean | null>(null)
  const navigate = useNavigate()
  const validateProjectNameSchema = Joi.string()
    .pattern(RegexConstants.NAME_REGEX)
    .required()
  const orgTimeZone = store.userStore.getOrganizationPreference().timeZone
  const formattedDateRange = dateRange(orgTimeZone)

  const ProjectTypeDropdownOptions = [
    {
      label: ProjectTypeDisplayNames.SALESFORCE_ONLY,
      value: ProjectType.SALESFORCE_ONLY
    },
    {
      label: ProjectTypeDisplayNames.FULL_STACK_ONLY,
      value: ProjectType.FULL_STACK_ONLY
    },
    {
      label: ProjectTypeDisplayNames.MULESOFT_ONLY,
      value: ProjectType.MULESOFT_ONLY
    }
  ]

  const SFecosystemProjectDropdownOptions = [
    {
      label: ProjectTypeDisplayNames.SALESFORCE_ONLY,
      value: ProjectType.SALESFORCE_ONLY
    },
    {
      label: ProjectTypeDisplayNames.MULESOFT_ONLY,
      value: ProjectType.MULESOFT_ONLY
    }
  ]

  const fullStackProjectDropdownOptions = [
    {
      label: ProjectTypeDisplayNames.FULL_STACK_ONLY,
      value: ProjectType.FULL_STACK_ONLY
    }
  ]

  const tab = [
    // {
    //   label:
    //     tabIndex === '1' ? (
    //       <DDSTypography.Title
    //         type='h5'
    //         variant='semiBold'
    //         color={palette.colors.primary2}
    //       >
    //         Errors
    //       </DDSTypography.Title>
    //     ) : (
    //       <DDSTypography.Title
    //         type='h5'
    //         variant='medium'
    //         color={palette.colors.textDark5}
    //       >
    //         Errors
    //       </DDSTypography.Title>
    //     ),
    //   children: (
    //     <div>
    //       <CCExceptionManagement />
    //     </div>
    //   )
    // },
    {
      label:
        tabIndex === '1' ? (
          <DDSTypography.Title
            type='h5'
            variant='semiBold'
            color={palette.colors.primary2}
          >
            API Monitoring
          </DDSTypography.Title>
        ) : (
          <DDSTypography.Title
            type='h5'
            variant='medium'
            color={palette.colors.textDark5}
          >
            API Monitoring
          </DDSTypography.Title>
        ),
      children: (
        <div>
          <CCApiMonitoring />
        </div>
      )
    }
    // {
    //   label:
    //     tabIndex === '3' ? (
    //       <DDSTypography.Title
    //         type='h5'
    //         variant='semiBold'
    //         color={palette.colors.primary2}
    //       >
    //         Uptime Checks
    //       </DDSTypography.Title>
    //     ) : (
    //       <DDSTypography.Title
    //         type='h5'
    //         variant='medium'
    //         color={palette.colors.textDark5}
    //       >
    //         Uptime Checks
    //       </DDSTypography.Title>
    //     ),
    //   children: (
    //     <div>
    //       <CCUptimeChecks />
    //     </div>
    //   )
    // },
    // {
    //   label:
    //     tabIndex === '4' ? (
    //       <DDSTypography.Title
    //         type='h5'
    //         variant='semiBold'
    //         color={palette.colors.primary2}
    //       >
    //         Scheduled Jobs
    //       </DDSTypography.Title>
    //     ) : (
    //       <DDSTypography.Title
    //         type='h5'
    //         variant='medium'
    //         color={palette.colors.textDark5}
    //       >
    //         Scheduled Jobs
    //       </DDSTypography.Title>
    //     ),
    //   children: (
    //     <div>
    //       <CCScheduledJobs />
    //     </div>
    //   )
    // },
    // {
    //   label:
    //     tabIndex === '5' ? (
    //       <DDSTypography.Title
    //         type='h5'
    //         variant='semiBold'
    //         color={palette.colors.primary2}
    //       >
    //         Incidents
    //       </DDSTypography.Title>
    //     ) : (
    //       <DDSTypography.Title
    //         type='h5'
    //         variant='medium'
    //         color={palette.colors.textDark5}
    //       >
    //         Incidents
    //       </DDSTypography.Title>
    //     ),
    //   children: (
    //     <div>
    //       <CCIncidents />
    //     </div>
    //   )
    // },
    // {
    //   label:
    //     tabIndex === '6' ? (
    //       <DDSTypography.Title
    //         type='h5'
    //         variant='semiBold'
    //         color={palette.colors.primary2}
    //       >
    //         Salesforce Audit
    //       </DDSTypography.Title>
    //     ) : (
    //       <DDSTypography.Title
    //         type='h5'
    //         variant='medium'
    //         color={palette.colors.textDark5}
    //       >
    //         Salesforce Audit
    //       </DDSTypography.Title>
    //     ),
    //   children: (
    //     <div>
    //       <CCScheduledJobs />
    //     </div>
    //   )
    // }
  ]

  const createProject = () => {
    store.uiStore.setGlobalLoader(true)
    store.projectStore.setLoading(true)

    const type = projectType
    setProjectType(type)

    CreateProject({
      name: projectName,
      projectType: type
    })
      .then(() => {
        store.projectStore.setProjects([])
        ToastNotification({
          type: 'success',
          message: ToastMessageConstants.PROJECT.CREATE.SUCCESS
        })
        navigate(
          replaceUrl(
            routeConstants.PROJECT_SETTING,
            store.scopeStore.getScope()['organization-id'] as string,
            store.scopeStore.getScope()['project-id'] as string,
            store.scopeStore.getScope()['environment-id'] as string
          )
        )
        setProjectName('')
        setProjectType('')
        setCreateProjectPopupOpen(false)
      })
      .catch((err) => {
        ToastNotification({
          type: 'error',
          message: err
        })
        setProjectName('')
        setProjectType('')
        setCreateProjectPopupOpen(false)
      })
      .finally(() => {
        store.uiStore.setGlobalLoader(false)
        store.projectStore.setLoading(false)
      })
  }

  const checkAvailability = () => {
    setCheckLoading(true)
    checkNameAvailability(
      UrlConstants.CHECK_PROJECT_NAME_AVAILABILITY.USECASE,
      projectName
    )
      .then((response: any) => {
        setIsNameAvailable(true)
        setCheckLoading(false)
        createProject()
      })
      .catch((error) => {
        setCheckLoading(false)
        ToastNotification({
          type: 'error',
          message:
            'Project name is already taken. Please enter a different name'
        })
        setIsNameAvailable(false)
      })
  }

  return (
    <div className='w-full h-full py-[12px]'>
      <div className='flex justify-between items-center w-full mb-[24px]'>
        <span
          style={{
            fontSize: 18,
            fontWeight: 5600,
            color: palette.colors.black
          }}
        >
          FullStack Project{' :'}
          <span
            style={{
              fontSize: 18,
              fontWeight: 600,
              color: palette.colors.black
            }}
          >
            {' '}
            {store.ccApiMonitoringStore.apiOverviewData.length}
          </span>
        </span>

        <div className='flex items-center gap-x-[16px]'>
          <SideChip
            id='date-range-chip'
            label='Date Range'
            value={formattedDateRange}
          />

          <Button
            id='create-project'
            type='filled'
            size='small'
            label='Create Project'
            onClick={() => setCreateProjectPopupOpen(true)}
            disabled={
              store.userStore.getNoActiveSubscription() ||
              store.userStore.getUserRole() !== OrganizationUserRoles.OWNER
            }
          />
        </div>
      </div>
      <div>
        <Tabs
          tabOptionsStyle={{
            minWidth: 'fit-content',
            display: 'flex',
            padding: '8px 12px ',
            justifyContent: 'center',
            alignItems: 'center',
            userSelect: 'none',
            width: 'auto',
            marginRight: '8px'
          }}
          disabled={store.uiStore.getGlobalLoader()}
          tabOptions={tab}
          id='tab-control-center'
          onChange={(index: any) => {
            setTabIndex(index.toString())
            const queryParams = getAllQueryParamsAsObjectFromUrl(
              location.search
            )

            setSearchParams({
              ...queryParams,
              page: '1',
              tab: index.toString()
            })
          }}
          activeTab={tabIndex}
        />
      </div>

      <div className='override-model-min-width'>
        <SettingAddPopup
          showHeader
          title='Create Project'
          modalOpen={createProjectPopupOpen}
          setModalOpen={setCreateProjectPopupOpen}
          primaryButtonText='Create Project'
          secondaryButtonText='Cancel'
          showFooter
          loading={store.projectStore.getLoading() || checkLoading}
          primaryButtonDisabled={
            store.projectStore.getLoading() ||
            !projectName ||
            !projectType ||
            checkLoading
          }
          secondaryButtonDisabled={
            store.projectStore.getLoading() || checkLoading
          }
          primaryButtonClick={checkAvailability}
          secondaryButtonClick={() => {
            setCreateProjectPopupOpen(false)
            setProjectName('')
            setProjectType('')
          }}
          content={
            <div className='flex flex-col p-[24px] gap-[24px]'>
              <DDSTypography.Title
                variant='semiBold'
                type='h4'
                color={palette.colors.textDark3}
              >
                {SettingConstants.MANAGE_APPLICATION}
              </DDSTypography.Title>

              <Input
                width='100%'
                onChange={(e) => setProjectName(e.target.value)}
                labelPosition='top'
                maxLength={StringConstants.NAME_FIELD_MAX_LENGTH}
                label={
                  <DDSTypography.Paragraph
                    size='para'
                    variant='medium'
                    color={palette.colors.textDark3}
                  >
                    {SettingConstants.PROJECT_NAME}
                  </DDSTypography.Paragraph>
                }
                id='input'
                name='Input'
                placeholder='Enter Project Name'
                required
                value={projectName}
                validateInput
                validate={(value: string) => {
                  if (!value.trim()) {
                    return {
                      error: true,
                      message: 'Project Name cannot be empty'
                    }
                  }
                  if (validateProjectNameSchema.validate(value).error) {
                    return { error: true, message: 'Project Name is invalid' }
                  }
                  if (isNameAvailable === false) {
                    return {
                      error: true,
                      message: 'Project Name already exists'
                    }
                  }
                  return { error: false, message: '' }
                }}
              />

              {store.userStore.getSelectedOrganization()?.type ===
                OrganizationType.HYBRID && (
                <Select
                  id='project-type'
                  required={true}
                  variant='top'
                  size='large'
                  name='Looking to Monitor'
                  label='Looking to Monitor'
                  options={ProjectTypeDropdownOptions}
                  searchable={false}
                  placeholder='Select Type'
                  onSelect={(value) => {
                    setProjectType(value)
                  }}
                />
              )}

              {store.userStore.getSelectedOrganization()?.type ===
                OrganizationType.SALESFORCE_ECOSYSTEM_ONLY && (
                <Select
                  id='project-type'
                  required={true}
                  variant='top'
                  size='large'
                  name='Looking to Monitor'
                  label='Looking to Monitor'
                  options={SFecosystemProjectDropdownOptions}
                  searchable={false}
                  placeholder='Select Type'
                  onSelect={(value) => {
                    setProjectType(value)
                  }}
                />
              )}

              {store.userStore.getSelectedOrganization()?.type ===
                OrganizationType.FULL_STACK_ONLY && (
                <Select
                  id='project-type'
                  variant='top'
                  required={true}
                  size='large'
                  name='Looking to Monitor'
                  label='Looking to Monitor'
                  options={fullStackProjectDropdownOptions}
                  searchable={false}
                  placeholder='Select Type'
                  onSelect={(value) => {
                    setProjectType(value)
                  }}
                />
              )}
            </div>
          }
        />
      </div>
    </div>
  )
}

export default observer(ControlCenter)
